module.exports = __webpack_public_path__ + "img/tips4@x2.1113c83f.png";